<template>
    <div class="c-box p-5">
        <div class="c-box__header mb-5">
            <div class="c-box__title text-center text-uppercase">
                Setup Account
            </div>
        </div>
        <div v-if="invitation_valid === false" class="alert alert-danger">
            The invitation data is not valid. Please verify the link used to access the panel.
        </div>
        <template v-else-if="create_account_sent === true">
            <div class="alert alert-info">
                <p>
                    Your account has been created!
                </p>
                <router-link :to="{ name: 'login.main', params: { company_id: c_id }  }" class="c-btn c-btn--success">
                    Sign In
                </router-link>
            </div>
        </template>
        <template v-else>
            <div class="c-form">
                <div class="row form-group c-form__group">
                    <label for="cId" class="col-12 c-form__label">Panel ID</label>

                    <div class="col-12">
                        <b-form-input disabled id="cId" v-model.trim="c_id"></b-form-input>
                    </div>
                </div>
                <div class="row form-group c-form__group">
                    <label for="user_email" class="col-12 c-form__label">User email</label>

                    <div class="col-12">
                        <b-form-input disabled id="user_email" v-model.trim="user_email"></b-form-input>
                    </div>
                </div>
                <div class="row form-group c-form__group">

                    <div class="col-5">
                      <label for="new_pass" class="c-form__label">New password</label>

                      <b-form-input type="password" id="new_pass" v-model="new_pass"></b-form-input>

                      <label for="repeat_pass" class="c-form__label">Confirm password</label>

                      <b-form-input type="password" id="repeat_pass" v-model="repeat_pass"></b-form-input>
                    </div>

                  <div class="col-7">
                    <p class="form-text text-muted">
                      New password must meet the following requirements:
                    </p>
                    <ul class="form-text text-muted">
                      <li> must be at least 8 characters long</li>
                      <li> must contain at least one lower case letter</li>
                      <li> must contain at least one upper case letter</li>
                      <li> must contain at least one number</li>
                      <li> must contain a special character</li>
                    </ul>
                  </div>

                </div>
                <div class="row form-group c-form__group">


                </div>
                <div class="row form-group c-form__group">
                    <div class="col-12">
                        <button
                            v-if="create_account_in_progress === false"
                            @click="create_account"
                            class="c-btn c-btn--success"
                        >
                            Create account
                        </button>
                        <button v-else disabled class="c-btn c-btn-default">
                            Loading...
                        </button>
                        <router-link :to="{ name: 'login.main', params: { company_id: c_id }  }" class="c-btn c-btn-default">
                            Sign In
                        </router-link>
                    </div>
                </div>
            </div>
        </template>
        <invite-account-main-ccs-modal></invite-account-main-ccs-modal>
    </div>
</template>

<script>
import CcsModal from "@/components/CcsModal.vue";

export default {
    metaInfo: {
        title: "Login"
    },

    components: {
        InviteAccountMainCcsModal: CcsModal
    },

    mounted() {},

    props: {
        invite_data: {
            type: String,
            default: ""
        }
    },

    data: function() {
        let user_company_id = 0;
        let user_invite_token = "";
        let user_email = "";
        let user_invitation_valid = false;

        try {
            let user_invite_data = JSON.parse(atob(this.invite_data));
            if (
                "company_id" in user_invite_data &&
                "invite_token" in user_invite_data &&
                "user_email" in user_invite_data
            ) {
                user_company_id = user_invite_data.company_id;
                user_invite_token = user_invite_data.invite_token;
                user_email = user_invite_data.user_email;
                user_invitation_valid = true;
            }
        } catch (err) {
            console.log("error parsing invite code");
        }

        let user_invite_data = JSON.parse(atob(this.invite_data));
        return {
            create_account_in_progress: false,
            create_account_sent: false,

            c_id: user_company_id,
            user_email: user_email,
            new_pass: "",
            repeat_pass: "",
            invite_token: user_invite_token,
            invitation_valid: user_invitation_valid
        };
    },

    watch: {},

    computed: {},

    methods: {
        create_account: function() {
            let payload = {
                company_id: this.c_id,
                user_email: this.user_email,
                invite_token: this.invite_token,
                new_pass: this.new_pass,
                repeat_pass: this.repeat_pass
            };

            this.create_account_in_progress = true;
            this.$store.dispatch("user/CreateAccountFromInvite", payload).then(
                (success_data) => {
                    this.create_account_in_progress = false;
                    this.create_account_sent = true;
                },
                (error_data) => {
                    this.create_account_in_progress = false;
                    this.$modal.show("invite-account-main-ccs-modal-dialog", {
                        type: "error",
                        title: "Could not complete create account request",
                        text: error_data,
                        buttons: [
                            {
                                title: "Close",
                                default: true // Will be triggered by default if 'Enter' pressed.
                            }
                        ]
                    });
                    return;
                }
            );
        }
    }
};
</script>
